var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6FBE45",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88872 11.3096C9.61505 11.4616 9.44531 11.7501 9.44531 12.0632V16.062C9.44531 19.1927 11.1426 22.0773 13.8794 23.5977L15.9231 24.7332C16.1835 24.8778 16.5001 24.8778 16.7605 24.7332L18.8042 23.5977C21.541 22.0773 23.2383 19.1927 23.2383 16.062V12.0632C23.2383 11.7501 23.0686 11.4616 22.7949 11.3096L16.7605 7.95712C16.5001 7.81247 16.1835 7.81247 15.9231 7.95712L9.88872 11.3096ZM15.4536 18.5264C15.7061 18.7789 16.1154 18.7789 16.3679 18.5264L19.8162 15.0782C20.0687 14.8257 20.0687 14.4163 19.8162 14.1638C19.5637 13.9113 19.1543 13.9113 18.9018 14.1638L15.9108 17.1549L14.6438 15.888C14.3913 15.6355 13.982 15.6355 13.7295 15.888C13.477 16.1405 13.477 16.5498 13.7295 16.8023L15.4536 18.5264Z",
    fill: "#6FBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationComplete);
export default __webpack_public_path__ + "static/media/verification-complete.a8968a49587743357554bba797bf68ea.svg";
export { ForwardRef as ReactComponent };